var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('MonthSelector',{on:{"select":_vm.load}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }